import { useState, useEffect } from 'react';
import {
    Chip, Button, Drawer, Select, MenuItem,
} from '@mui/material';
import './WarningsPanel.scss';
import { Warning as WarningIcon, Close as CloseIcon, Check } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import WarningType, { WarningTypeNames } from '../../../enums/WarningType';


const ALL_WARNINGS = 'all';

const warningTypeFilterOptions = [
    { value: ALL_WARNINGS, labelKey: 'allWarnings' },
    { value: WarningType.Bid, labelKey: WarningTypeNames[WarningType.Bid] },
    { value: WarningType.Employee, labelKey: WarningTypeNames[WarningType.Employee] },
];

/** @param {{warningsCount: number, onClose: () => void }} param0 */
const WarningsPanelHeader = ({ warningsCount, onClose }) => {
    const { t } = useTranslation('bid', { keyPrefix: 'warnings' });
    return (
            <div className="warnings-panel-header">
                <Button className="warning-card-close-button" onClick={onClose}>
                    <CloseIcon/>
                </Button>
                <div>{t('header')}</div>            
                <Chip
                    className="warnings-panel-header-chip"
                    label={`${warningsCount}`}
                />
            </div>
    );
};

/** @param {{data: import('./typing').WarningCard}} data */
const WarningCard = ({ data }) => {
    
    const isThereAnEmployeeList = data.employees && data.employees.length > 0;

    return (
        <div className="warning-card-container">
            <div className="warning-icon">
                <WarningIcon />
            </div>
            <div className="warning-card-message">{data.warningMessage}</div>
            <div className="warning-card-description">{data.warningDescription}</div>
            {isThereAnEmployeeList && (
                <div className="warning-card-employees-container">
                    {// @ts-ignore
                        data.employees.map((employee) => (
                        <Chip
                            className="warning-card-employee-chip"
                            label={`${employee.name} (${employee.rank})`}
                        />
                    ))}
                </div>
            )}
            {data.actionButtonLabel && (
                <Button className="warning-card-action-button" onClick={data.action}>
                    {data.actionButtonLabel}
                </Button>
            )}
        
        </div>
    );
};

/**
 * @param {import('./typing').WarningsPanelProps} props
 */
function WarningsPanel({
    isDrawerOpen,
    onClose,
    warningCards,
}) {
    const { t } = useTranslation('bid', { keyPrefix: 'warnings' });
    const [selectedWarningType, setSelectedWarningType] = useState(ALL_WARNINGS);

    useEffect(() => {
        if (!isDrawerOpen) {
            setSelectedWarningType(ALL_WARNINGS);
        }
    }, [isDrawerOpen]);

    const filteredWarningCards = selectedWarningType === ALL_WARNINGS
        ? warningCards
        // @ts-ignore
        : warningCards.filter((card) => card.warningType === selectedWarningType);

    const orderedWarningCards = filteredWarningCards.sort((a, b) => a.warningType - b.warningType);

    const handleFilterChange = (event) => {
        setSelectedWarningType(event.target.value);
    };

    return (

            <Drawer
                className="bid-warnings-panel-drawer"
                anchor="right"
                open={isDrawerOpen}
                onClose={onClose}
                ModalProps={{ closeAfterTransition: true }}
            >
                <WarningsPanelHeader
                    warningsCount={warningCards.length}
                    onClose={onClose}
                />
                <div className="bid-warnings-panel-container">
                    <Select
                        className="warning-type-filter"
                        value={selectedWarningType}
                        onChange={handleFilterChange}
                        MenuProps={{
                            className: 'warning-type-filter-menu',
                            disablePortal: true,
                        }}
                    >
                            {warningTypeFilterOptions.map((opt) => (
                                <MenuItem
                                    key={opt.value}
                                    value={opt.value}
                                    sx={{
                                        fontWeight: opt.value === selectedWarningType ? 'bold' : 'normal',
                                    }}
                                >
                                    {t(opt.labelKey)}
                                </MenuItem>
                            ))}
                    </Select>
                    {orderedWarningCards.map((warningCards) => (
                        <WarningCard
                            data={warningCards}
                        />
                    ))}
                </div>
            </Drawer>
    );
}

export default WarningsPanel;
